<template>
  <el-dialog
    title="Add Size Chart"
    :visible.sync="dialogVisible"
    width="680px">
    <div>
      <temu-create-template
        ref="temuCreateTemplate"
        templateType="temuTemplate"
        :sizeAttr="sizeAttr"
        :elementList="elementList"
        :classId="classId"
        :className="className"
        :checkSizeList="checkSizeList"
      ></temu-create-template>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">Cancel</el-button>
      <el-button :loading="loading" type="primary" @click="temuCreateSizeCharts">Confirm</el-button>
    </span>
  </el-dialog>
</template>

<script>
import API from '@/api'
import temuCreateTemplate from './temuCreateTemplate.vue'
export default {
  components: { temuCreateTemplate },
  props: {
    elementList: {
      type: Array,
      default: () => []
    },
    groupList: {
      type: Array,
      default: () => []
    },
    sizeAttr: {
      type: Object,
      default: () => {}
    },
    storeId: {
      type: [String, Number],
      default: () => ''
    },
    catId: {
      type: [String, Number],
      default: () => ''
    },
    classId: {
      type: [String, Number],
      default: () => ''
    },
    className: {
      type: String,
      default: () => ''
    },
    // 选中的尺码size （XS, S, M, L...）
    checkSizeList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false
    }
  },
  methods: {
    show() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.temuCreateTemplate.initTemplate('add')
      })
    },
    // 创建尺码表模板
    temuCreateSizeCharts() {
      let list = this.$refs.temuCreateTemplate.multipleSelection
      list.forEach(t => {
        for (let k in t) {
          if (!this.$refs.temuCreateTemplate.checkSize.includes(+k) && +k !== 1) delete t[k]
        }
      })
      let data = {
        storeId: this.storeId,
        catId: this.catId,
        classId: this.classId,
        className: this.className,
        name: this.$refs.temuCreateTemplate.templateName,
        reusable: true,
        content: {
          meta: {
            elementList: this.elementList.filter(t => this.$refs.temuCreateTemplate.checkSize.includes(t.id)).map(t => ({ id: t.id, name: t.name })),
            groupList: this.groupList.map(t => ({ id: t.id, name: t.name }))
          },
          records: list.map(t => ({ values: t }))
        }
      }
      this.$emit('temuCreateSizeCharts', data, 'temuTemplate')
    }
  }
}
</script>

<style scoped lang="scss">

</style>
